import React from 'react'
import './Account.css'
import LoginScaffold from './LoginScaffold.js'
import {sendPasswordResetEmail} from './resetPasswordActions.js'

class ForgotPasswordForm extends React.Component<{}, {
    email: string, error: string, sending: boolean, displaySuccess: boolean, ready: boolean
}> {
    state = {email: '', error: '', sending: false, displaySuccess: false, ready: false}

    componentDidMount() {
        const displaySuccess = sessionStorage.getItem('passwordResetSent') === 'true'
        sessionStorage.removeItem('passwordResetSent')
        this.setState({displaySuccess, ready: true})
    }

    async sendReset(email: string) {
        this.setState({sending: true, error: ''})
        try {
            const response = await sendPasswordResetEmail(email)
            if (!response.success) throw new Error(response.message || 'Could not send the reset email.')
            this.setState({displaySuccess: true})
        } catch (error) {
            this.setState({error: error instanceof Error ? error.message : 'Could not send the reset email.'})
        } finally {
            this.setState({sending: false})
        }
    }

    submit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
        void this.sendReset(this.state.email)
    }

    render() {
        return <LoginScaffold>
            {!this.state.ready ? null : this.state.displaySuccess
                ? <header className="Login-header" role="status">Check your email for a password reset link.</header>
                : <div>
                        <header className="Login-header">Enter your email to receive a password reset link.</header>
                        {this.state.error && <p className="Login-header-error" role="alert">{this.state.error}</p>}
                        <form className="Login-form" onSubmit={event => this.submit(event)}>
                            <div>
                                <input autoFocus type="email" required className="Login-input" placeholder="Email"
                                    aria-label="Email" value={this.state.email}
                                    onChange={event => this.setState({email: event.target.value})} />
                            </div>
                            <button type="submit" className="primary" disabled={this.state.sending}>Send request</button>
                        </form>
                    </div>
            }
        </LoginScaffold>
    }
}

export default ForgotPasswordForm
